import React, { useState } from "react";
import { Outlet, NavLink, useLocation } from "react-router-dom";
import { ScanLine, Menu, BarChart2 } from "lucide-react";
import SideBarMenu from "./SideBarMenu"; 

const tabs = [
  { to: "/dashboard", label: "Dashboard", icon: BarChart2, testid: "tab-dashboard" },
  { to: "/capture", label: "Scan", icon: ScanLine, testid: "tab-capture", primary: true },
  { isMenu: true, label: "Menu", icon: Menu, testid: "tab-menu" },
];

export default function PhoneShell() {
  const location = useLocation();
  const hideNav = location.pathname.startsWith("/auth");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="phone-shell pb-28">
      <Outlet />

      <SideBarMenu isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

      {!hideNav && (
        <nav
          data-testid="bottom-nav"
          className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-40 bg-white/95 backdrop-blur-xl border-t border-zinc-200"
          style={{
            paddingBottom: "env(safe-area-inset-bottom, 0px)",
          }}
        >
          <div className="grid grid-cols-3 h-20">
            {tabs.map((tab) => (
              tab.isMenu ? (
                <button
                  key="menu"
                  onClick={() => setIsSidebarOpen(true)}
                  data-testid={tab.testid}
                  className="flex flex-col items-center justify-center gap-1 text-[10px] sm:text-xs font-semibold transition-colors text-zinc-400 hover:text-zinc-700 cursor-pointer"
                >
                  <tab.icon className="h-5 w-5" strokeWidth={2} />
                  <span>{tab.label}</span>
                </button>
              ) : (
                <NavLink
                  key={tab.to}
                  to={tab.to}
                  data-testid={tab.testid}
                  className={({ isActive }) =>
                    `flex flex-col items-center justify-center gap-1 text-[10px] sm:text-xs font-semibold transition-colors ${
                      tab.primary
                        ? "relative"
                        : isActive
                        ? "text-zinc-950"
                        : "text-zinc-400 hover:text-zinc-700"
                    }`
                  }
                >
                  {tab.primary ? (
                    <span className="absolute -top-5 inline-flex h-14 w-14 items-center justify-center rounded-full bg-zinc-950 text-white shadow-lg shadow-zinc-900/20 active:scale-95 transition-transform">
                      <tab.icon className="h-6 w-6" strokeWidth={2.5} />
                    </span>
                  ) : (
                    <tab.icon className="h-5 w-5" strokeWidth={2} />
                  )}
                  <span className={tab.primary ? "mt-9 text-zinc-950" : ""}>{tab.label}</span>
                </NavLink>
              )
            ))}
          </div>
        </nav>
      )}
    </div>
  );
}